import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { useRoute } from '@nuxtjs/composition-api';

import { useElementHover } from '@vueuse/core';
import HeaderMainMenuItem from '~/domains/menus/components/HeaderMainMenuItem.vue';

interface Props {
  menu?: any[];
  menuWrapperRef?: any;
  isOpen?: boolean;
  dark?: boolean;
}
interface Emits {
  (e: 'toggle-menu', data: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderMainMenu',
  props: {
    menu: { default: () => [] },
    menuWrapperRef: { default: null },
    isOpen: { type: Boolean, default: false },
    dark: { type: Boolean, default: false }
  },
  emits: ["toggle-menu"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'toggle-menu', data: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menu: any[], menuWrapperRef: any, isOpen: boolean, dark: boolean };




const route = useRoute();
const menuRef = computed(() => props.menuWrapperRef);
const isHovered = useElementHover(menuRef);
const activeItem = ref<null | number>(null);

const setActiveItem = (id: number) => {
  activeItem.value = id;
};

watch(isHovered, (value) => {
  if (value === false) activeItem.value = null;
});

watch(route, () => {
  activeItem.value = null;
});

watch(activeItem, (value) => {
  emit('toggle-menu', Boolean(value));
});

return { __sfc: true,props, emit, route, menuRef, isHovered, activeItem, setActiveItem, HeaderMainMenuItem }
}

})